export function splitFileNameAndExtension(
  fileNameWithExt: string
): [fileName: string, extension: string] {
  const lastDotIndex = fileNameWithExt.lastIndexOf(".");
  if (lastDotIndex === -1) {
    return [fileNameWithExt, ""];
  }
  return [
    fileNameWithExt.substring(0, lastDotIndex),
    fileNameWithExt.substring(lastDotIndex + 1)
  ];
}
